"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleSelectFieldValueGetter = void 0;
const safe_field_value_1 = require("../safe-field-value");
const primitives_1 = require("../type-checking/primitives");
class SingleSelectFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            return (0, primitives_1.isStringValue)(fieldValue);
        };
        this.getEmptyValue = () => "";
    }
}
exports.SingleSelectFieldValueGetter = SingleSelectFieldValueGetter;
